import React from 'react';
import { connect } from 'react-redux'
import { Spin } from 'antd';

const Loaded = ({IRI}) => <span>{IRI}&nbsp;<Spin size="small" /></span>

/** Отображение элемента по ссылки. В качестве параметров:
 * 1. IRI Объекта - IRI который, необходимо показать
 * 2. factory - фабрика, используемые для получения наименование
 * 3. triplet - информация об записи. Может включать в себя:
 *   - URI ObjectProperty - URI объектного свойства, которое содержало IRI (опциональной)
 *   - языковую константу
 *   - IRI объекта,
 * например { "predicat": { "type": "uri", "value": "http://purl.org/dc/terms/creator" }	, 
 *            "object"  : { "type": "uri", "value": "http://semanticpro.org/adms/dan_brickley", "xml:lang": "ru" }}
 * 4. lang - текущий язык
 * 5. graph - граф с данным
 */ 
export class BaseViewLinkComponent extends React.Component {

  state = {
    //Статус загрузки
    loading: false,
    //Значение
    value: undefined
  };

  /** Вызывается сразу после монтирования компонента (вставки в дерево).  
   * см. https://legacy.reactjs.org/docs/react-component.html#componentdidmount */
  componentDidMount(){
    if (this.props.IRI)
      this.makeValue();
  };

  /** Вызывается сразу после обновления. Этот метод не вызывается для первоначального рендеринга. 
   * см. https://legacy.reactjs.org/docs/react-component.html#componentdidupdate */
  componentDidUpdate(prevProps){
    if (this.props.IRI){
      if (prevProps.IRI != this.props.IRI)
        this.makeValue(true);
    } else {
      this.setState({loading: false, value: undefined});
    };
  };

  makeValue (reload = false) {
    const { IRI, factory, triplet, lang, graph } = this.props;
    //Если нет требования перегрузить и идёт процесс загрузки
    if (!reload && this.state.loading)
      return;
    this.setState({loading: true, value: IRI})
    if (!factory || !this.props.dispatch ){  //Фабрика отсутствует
      this.setState({loading: false, value: IRI});
      return;
    };
    //Данные уже считали
    if ((triplet) && triplet["rdfs:label"]){
      this.setState({loading: false, value: triplet["rdfs:label"]});
      return;
    };
    this.props.dispatch(factory.provider.getLabelOrTitleByIRI(IRI, lang, triplet))
      .then(response => {
        //console.log("ViewLink.js makeValue", IRI, lang, triplet, response);
        if (response.label == IRI){
          this.setState({loading: false, value: response.noLangLabel});
        } else {
          this.setState({loading: false, value: response.label});
        }
      })
      .catch(e => { 
        this.setState({loading: false, value: IRI+ " !!!"});
        console.log("Error!", e);
    });
  }

  render(){
    //console.log(this);
    const { IRI } = this.props;
    const {loading, value} = this.state;
    return(
      (loading?
        <Loaded IRI={IRI} />
      :
        <span style={{"display": "inline"}}>{value}</span>
      )
    )
  }
}

function mapStateToProps(state, props) {
  //Значения в store redux. vset - для значений по умолчнию, vowl
  const {vset} = state;
  //Параметры, которые могут прийти из настроек
  const {graph, IRI, lang, triplet, factory } = props;
  // //Ищем считанные из значения свойств
  // const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, iri):[];
  return {
    IRI,
    factory,
    triplet,
    graph: (graph)? graph: vset.graph,
    lang: (lang)?lang: vset.lang,
  };
}

/** Компонента, смапированная на vset */
export const SimpleViewLinkComponent = connect(mapStateToProps)(BaseViewLinkComponent);